/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import React, { Component } from "react";
import { Button } from "carbon-addons-iot-react";
import { ReactComponent as NotAuthorized} from '../icons/Not-authorized.svg';
import {NO_SESSION_HEADING,NO_SESSION_BODY,NO_SESSION_LOGIN}  from "../utils/ApplicationMessages";
class SessionExpired extends Component {

    render(){
        let location =  window.location.href;
        if(location.includes("#")){
          location = location.split("#")[0];
        }
        if(location.includes("?")){
          location = location.split("?")[0];
        }
        let login = location.replace("/app/tririga","/login").replace("login/","login");
        
        let message_json = localStorage.getItem('triPlatformNavMessages');
        let messages = {};
        if(message_json.length > 0){
            messages = JSON.parse(message_json);
        }

        let heading_text = messages[NO_SESSION_HEADING]?
        messages[NO_SESSION_HEADING]:
        "You do not have permission to access this page.";

        let body_text = messages[NO_SESSION_BODY]?
        messages[NO_SESSION_BODY]:
        "Due to either a session timeout or unauthorized access, you do not have permission to access this page.";

        let login_text = messages[NO_SESSION_LOGIN]?
        messages[NO_SESSION_LOGIN]:
        "Log in";

        return (
            <div style={{paddingLeft:'10%',paddingTop:'10%',width:'80%'}}>
                <NotAuthorized/>
                <div style={{paddingTop:'30px',width:'50%'}}>
                <h2 ><b>{heading_text}</b></h2>
                </div>
                <div style={{paddingTop:'20px',width:'50%'}}>
                {body_text}
                </div>
                <div style={{paddingTop:'20px',width:'50%'}}>
                <Button
                    kind="primary"
                    onClick={(event)=>{
                        /* eslint eqeqeq: 0 */
                        if(window.top!=window.self){
                            var path_parts = window.location.href.split("/app/tririga");
                            var top_location = window.top.location.href;
                            if(top_location.indexOf('/html/en/default/admin/')>0){
    				            window.top.location = path_parts[0] + "/html/en/default/admin/index.jsp";
                            }else{
                                window.top.location = path_parts[0] + "/login"; 
                            }                       
                        }else{
                            window.location = login;
                        }
                    }}
                    size="default"
                >
                    {login_text}
                </Button>
                </div>
            </div>
        );
    }
}

export default SessionExpired;
